import "touchr";
import "vue-selector/dist/vue-selector.css";
import "vue-loading-overlay/dist/vue-loading.css";
// import VTooltip from "v-tooltip";
import "vuescroll/dist/vuescroll.css";
import "../../assets/scss/overrides";
import "../../assets/scss/site";

import { Client, Contact, LogoTypeNames, RecruitmentAgency } from "@timesheets/constants-common";
import { PageTypes, TRouteMetaGroup } from "@/routing";
import { createVue, getHeaderImageUrl, report } from "@/utils";

// import Beta from "Components/Beta/Index";
import Block from "Components/Block/Index.vue";
import Dashboard from "./Index.vue";
import Date from "Components/Date/Index.vue";
// @ts-ignore
import Datepicker from "vuejs-datepicker";
import Dropdown from "Components/Dropdown/Index.vue";
import EditableControl from "Components/EditableControl/Index.vue";
import Errors from "Components/Errors.vue";
import { GemmaError } from "@gemma/errors";
import { IEvent } from "@gemma/events";
import { IState } from "../../vuex/IState";
import { IWebApplication } from "@timesheets/webapp-support";
// @ts-ignore
import InfiniteLoading from "vue-infinite-loading/src";
import Input from "Components/Input/Index.vue";
import ItemSection from "Components/ItemSection/Index.vue";
import Loading from "vue-loading-overlay";
import Navigation from "Dashboard/components/Navigation/Index.vue";
// @ts-ignore
import PrettyCheckbox from "pretty-checkbox-vue";
import { Route } from "@gemma/utils";
import SaveSetting from "Components/Settings/SaveSetting/Index.vue";
import SortableHeader from "Components/SortableHeader/Index.vue";
import { Store } from "vuex";
import SystemError from "@/pages/SystemError/Index.vue";
import TabGroup from "Components/TabGroup/Index.vue";
import Toggle from "Components/Toggle/Index.vue";
import ToggleButton from "vue-js-toggle-button";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";
import { VueConstructor } from "vue/types/umd";
import { VueFormSlideout } from "@/plugins/vue-form-slideout";
import VueRouter from "vue-router";
// @ts-ignore
import VueSelector from "vue-selector";
import { WebApplicationConstants } from "../../setup/WebApplicationConstants";
import { formValidation } from "@timesheets/validators-common";
import { initialize } from "../initialize";
import { registrations } from "../../setup";
import { routes } from "./routes";
import { sync } from "@gemma/linq";
// import { setHeaderImageUrl } from "./components/Roles/RolesList/setHeaderImageUrl";
// @ts-ignore
import vuescroll from "vuescroll/dist/vuescroll-native";

(async function() {
  try {
    const result = await initialize(PageTypes.Dashboard, routes);
    let router: VueRouter;
    let store: Store<IState>;
    let webApplication: IWebApplication<Route<TRouteMetaGroup>>;

    if (result) {
      ({ router, store, webApplication } = result);
    } else {
      return;
    }

    registrations(router, store, webApplication);

    Vue.use(Vue2TouchEvents);
    Vue.component("SystemError", SystemError);

    formValidation(Contact, Client);

    Vue.use(PrettyCheckbox);
    Vue.use(InfiniteLoading, {
      /* options */
    });
    Vue.use(Loading);
    Vue.use(vuescroll);
    Vue.use(ToggleButton);
    // Vue.use(VTooltip);

    // Vue.component("Beta", Beta);
    Vue.component("Errors", Errors);
    Vue.component("Loading", Loading);
    Vue.component("Navigation", Navigation);
    Vue.component("VueFormSlideout", VueFormSlideout);
    Vue.component("VueSelector", VueSelector);
    Vue.component("ItemSection", ItemSection);
    Vue.component("Datepicker", Datepicker);

    Vue.component("Input", (Input as unknown) as VueConstructor);
    Vue.component("Date", (Date as unknown) as VueConstructor);
    Vue.component("Toggle", (Toggle as unknown) as VueConstructor);
    Vue.component("Block", Block);
    Vue.component("Dropdown", (Dropdown as unknown) as VueConstructor);
    Vue.component("EditableControl", (EditableControl as unknown) as VueConstructor);
    Vue.component("SortableHeader", SortableHeader);
    Vue.component("TabGroup", TabGroup);
    Vue.component("SaveSetting", SaveSetting);

    await createVue(webApplication, (Dashboard as unknown) as VueConstructor, { name: "Dashboard", router, store });

    // Note: This MUST be registered after the equivalent subscription in createVue, in order that the timestamp is updated beforehand to cache-bust. (Maybe update to depend on Square/RectangularUpdated events)
    WebApplicationConstants.eventBus.createFilters([RecruitmentAgency.SetSquareLogo, RecruitmentAgency.DeleteSquareLogo, RecruitmentAgency.SetRectangularLogo, RecruitmentAgency.DeleteRectangularLogo]).addSubscription(
      (event: IEvent<{ canonicalTenantName: string; logoType: LogoTypeNames }, string>) => {
        const canonicalTenantName = event.data.canonicalTenantName;
        const recruitmentAgencies = sync.Enumerable.from(store.state.user.roles)
          .where(role => role.recruitmentAgency.names.currentCanonical === canonicalTenantName)
          .select(role => role.recruitmentAgency)
          .uniqueBy()
          .toArray();

        for (const recruitmentAgency of recruitmentAgencies) {
          switch (event.type) {
            case RecruitmentAgency.SetSquareLogo.EventName:
              recruitmentAgency.settings.logos.square = getHeaderImageUrl(canonicalTenantName, false, store);
              break;

            case RecruitmentAgency.DeleteSquareLogo.EventName:
              recruitmentAgency.settings.logos.square = false;
              break;

            case RecruitmentAgency.SetRectangularLogo.EventName:
              recruitmentAgency.settings.logos.rectangular = getHeaderImageUrl(canonicalTenantName, true, store);
              break;

            case RecruitmentAgency.DeleteRectangularLogo.EventName:
              recruitmentAgency.settings.logos.rectangular = false;
              break;
          }
        }
      },
      undefined,
      WebApplicationConstants
    );
  } catch (innerError) {
    await report.error(innerError as GemmaError, WebApplicationConstants.show.errorOverlay);
    throw innerError;
    // }
  }
})();
